module.exports = __webpack_public_path__ + "img/Cloud-migration.9b30eaa.webp";